<div class="w-full h-full bg-[#fcfcfd] z-[999999999999] flex justify-center items-center">
    <img *ngIf="pageType == 'woqod'" src="assets/images/default-img.gif" class="w-64 h-64" />
    <img *ngIf="pageType == 'fahes'" src="assets/images/Fahes_loader_new.gif" class="w-64 h-64" />  
  <img *ngIf="pageType == 'qjet'" src="assets/images/Qjet_loader_new.gif" class="w-64 h-64" />    
</div>